/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleExtra
 */
export interface VehicleExtra {
    /**
     * 
     * @type {string}
     * @memberof VehicleExtra
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleExtra
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleExtra
     */
    amount?: string;
    /**
     * Charge type (PerDay, Rental, Percent)
     * @type {string}
     * @memberof VehicleExtra
     */
    type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleExtra
     */
    includedInRate?: boolean;
    /**
     * Whether this extra is an insurance or protection product (CDW, LDW, PAI, SLI, etc.)
     * @type {boolean}
     * @memberof VehicleExtra
     */
    isInsurance?: boolean;
}

/**
 * Check if a given object implements the VehicleExtra interface.
 */
export function instanceOfVehicleExtra(value: object): value is VehicleExtra {
    return true;
}

export function VehicleExtraFromJSON(json: any): VehicleExtra {
    return VehicleExtraFromJSONTyped(json, false);
}

export function VehicleExtraFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleExtra {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'type': json['type'] == null ? undefined : json['type'],
        'includedInRate': json['included_in_rate'] == null ? undefined : json['included_in_rate'],
        'isInsurance': json['is_insurance'] == null ? undefined : json['is_insurance'],
    };
}

export function VehicleExtraToJSON(json: any): VehicleExtra {
    return VehicleExtraToJSONTyped(json, false);
}

export function VehicleExtraToJSONTyped(value?: VehicleExtra | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'amount': value['amount'],
        'type': value['type'],
        'included_in_rate': value['includedInRate'],
        'is_insurance': value['isInsurance'],
    };
}

